export default {"src":"/_next/static/media/CVX.cd72027d.svg","height":18,"width":18};